// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"432":"991b2866","721":"991b2866","950":"991b2866","989":"991b2866"}[chunkId] + ".css";
};